import {
  Component,
  ViewChild,
  ElementRef,
  EventEmitter,
  OnInit,
  ChangeDetectorRef
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

import * as _ from "lodash";
import { Subscription } from "rxjs";

import { BaseComponent } from "../_base.component";

import { PopoverComponent } from "../../../../popover";

/**
 * @ignore
 */
@Component({
  selector: "uex-input-typeahead",
  templateUrl: "./typeahead.component.html",
  host: {
    class: "uex-input-typeahead"
  }
})
export class InputTypeaheadComponent extends BaseComponent<any>
  implements OnInit {
  @ViewChild("dropdown", { static: false }) dropdown: ElementRef;
  @ViewChild("popover", { static: false }) popover: PopoverComponent;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _domSanitizer: DomSanitizer
  ) {
    super();
  }

  public onSearchComplete: EventEmitter<any> = new EventEmitter();

  public first_focus = false;

  public search_input_value = "";

  public search_loading = false;
  public search_typing = false;
  public search_active_index = 0;

  private _last_search_value: string;

  private _search_self_focus = false;
  private _search_timeout: any;
  private _blur_subscription: Subscription;
  private _value_subscription: Subscription;

  public ngOnInit() {
    // Ã importante utilizar o "control.value" para garantir que irÃ¡ obter o valor puro, sem a formataÃ§Ã£o realizada pelo "get value " do schema
    this._setValue(this.control.value || null);
  }

  public onReset() {
    this.resetSearch(false);
    this._setValue(this.schema.default_value);
  }

  public onValueSetted(new_value: any) {
    this._setValue(new_value);
  }

  public ngOnDestroy() {
    if (this._value_subscription) {
      this._value_subscription.unsubscribe();
    }
  }

  public resetSearch(emit_event: boolean = true) {
    if (this._search_timeout) {
      clearTimeout(this._search_timeout);
    }

    const value_changed = (this.value || null) != null;
    this.value = null;

    this.schema.search_list = [];

    this._last_search_value = null;
    this.search_input_value = null;

    this.search_loading = false;
    this.search_active_index = 0;

    if (emit_event && value_changed) {
      this.onChange(this.value);
    }
  }

  public select(index: number, event?: MouseEvent) {
    if (this.schema.search_list.length == 0) {
      return;
    }
    this._setValue(this.schema.search_list[index]);
    this.search_active_index = index;
    this.onChange(this.value);
    if (event) {
      this._search_self_focus = true;
      setTimeout(() => this.schema.focus());
    }
  }

  public selectActive() {
    this.select(this.search_active_index);
  }

  public onSearchKeydown(event: KeyboardEvent) {
    const keyCode = event.which || event.keyCode;
    switch (keyCode) {
      // Arrow up
      case 38:
        event.preventDefault();
        if (this.search_active_index > 0) {
          this.search_active_index--;
        } else {
          this.search_active_index = this.schema.search_list.length - 1;
        }
        this._ajustScroll();
        break;

      // Arrow down
      case 40:
        event.preventDefault();
        if (this.search_active_index < this.schema.search_list.length - 1) {
          this.search_active_index++;
        } else {
          this.search_active_index = 0;
        }
        this._ajustScroll();
        break;

      // Tab key
      case 9: // Tab
      case 16: // Shift
      case 17: // Ctrl
      case 20: // Caps Lock
      case 37: // Arrow left
      case 39: // Arrow right
      case 255: // AltGr
        break;

      // Right return
      case 13:
        event.preventDefault();
        this.selectActive();
        break;

      // Escape
      case 27:
        this.resetSearch();
        break;

      default:
        this.search_typing = true;
    }
    this.onKeydown(event);
  }

  public onSearchKeyup(event: KeyboardEvent) {
    const keyCode = event.which || event.keyCode;
    switch (keyCode) {
      case 9: // Tab
      case 13: // Right return
      case 16: // Shift
      case 17: // Ctrl
      case 20: // Caps Lock
      case 37: // Arrow left
      case 38: // Arrow top
      case 39: // Arrow right
      case 40: // Arrow bottom
      case 255: // AltGr
        event.preventDefault();
        break;
      default:
        this.control.markAsDirty({ onlySelf: true });
        this._doSearch();
    }
    this.onKeyup(event);
  }

  public onSearchFocus(event: any) {
    if (this._blur_subscription) {
      this._blur_subscription.unsubscribe();
    }
    this.onFocus(event);
    if (this.schema.select_on_focus) {
      this.elementRef.nativeElement.select();
    }
    // this.unfreezeSearch();
    this.first_focus = true;
    if (this.schema.search_on_focus) {
      if (this._search_self_focus) {
        this._search_self_focus = false;
      } else {
        this._doSearch(true);
      }
    }
  }

  public onSearchBlur(event: any) {
    if (this.schema.match_only && (this.search_loading || this.search_typing)) {
      this._blur_subscription = this.onSearchComplete.subscribe(list => {
        this._blur_subscription.unsubscribe();
        this._afterBlur();
      });
    } else {
      if (this._search_timeout) {
        clearTimeout(this._search_timeout);
      }
      this._afterBlur();
    }
    this.onBlur(event);
  }

  public onSearchChange(event: any) {}

  public getLabelHtml(item): SafeHtml {
    let label = "";
    if (_.isFunction(this.schema.search_list_format)) {
      label = this.schema.search_list_format(item);
    } else {
      const _label_accessor = _.at(item, this.schema.search_list_accessor)[0];
      if (_label_accessor) {
        label = this._applyMatchValue(_label_accessor);
      }
    }
    return this._domSanitizer.bypassSecurityTrustHtml(label);
  }

  public getInputString(item): string {
    let label = "";
    if (item == null) {
      return label;
    } // Previne erro no format caso o form sera resetado
    if (_.isFunction(this.schema.search_input_format)) {
      label = this.schema.search_input_format(item);
    } else {
      const _label_accessor = _.at(item, this.schema.search_input_accessor)[0];
      if (_label_accessor) {
        label = _label_accessor.toString();
      }
    }
    return label;
  }

  public isEmptyList(): boolean {
    return (
      !this.schema.search_list ||
      (this.schema.search_list && this.schema.search_list.length == 0)
    );
  }

  public allowValidate(): boolean {
    return (
      this.control &&
      this.control.dirty &&
      this.control.touched &&
      (this.value || _.isEmpty(this.search_input_value))
    );
  }

  public allowShowDropdown(): boolean {
    return (
      this.schema.focused &&
      !this.search_loading &&
      !this.search_typing &&
      (!this.value || this.schema.always_show_list)
    );
  }

  public allowShowDropdownTypeToSearch(): boolean {
    return !this.search_input_value && this.isEmptyList();
  }

  public allowShowDropdownEmptySearch(): boolean {
    return this.search_input_value && this.isEmptyList();
  }

  private _doSearch(force_search: boolean = false) {
    if (this._search_timeout) {
      clearTimeout(this._search_timeout);
    }

    const search_input_value = this.search_input_value;

    if (search_input_value != this._last_search_value || force_search) {
      this.value = null;
      this.search_active_index = 0;

      this._search_timeout = setTimeout(() => {
        this.search_typing = false;

        this.schema.search_list = [];
        this.search_loading = true;

        this._last_search_value = search_input_value;

        if (this.schema.search) {
          this.schema.search(search_input_value, response => {
            if (this.search_input_value == search_input_value) {
              if (_.isArray(response)) {
                this.schema.search_list = response;
              } else {
                this.schema.search_list = [];
              }
            }

            this.search_active_index = 0;
            this.search_loading = false;
            this._changeDetectorRef.detectChanges();
            if (this.popover) {
              setTimeout(() => this.popover.update());
            }
            this.onSearchComplete.emit(this.schema.search_list);
          });
        } else {
          this.search_loading = false;
        }
      }, this.schema.debounce);
    }
  }

  private _setValue(value) {
    if ((value || null) != (this.control.value || null)) {
      this.schema.value = value;
    }
    this.search_input_value =
      this.getInputString(value) || (this.value ? this.value.toString() : "");
    this._last_search_value = this.search_input_value;
  }

  private _afterBlur() {
    if (this.value) {
      return;
    }
    if (this.schema.search_list.length > 0) {
      if (this.schema.match_only) {
        this.selectActive();
      } else {
        const value_changed =
          (this.search_input_value || null) != (this.value || null);
        this._setValue(this.search_input_value);
        if (value_changed) {
          this.onChange(this.value);
        }
      }
    } else {
      if (this.schema.match_only) {
        this.resetSearch();
      } else {
        const value_changed =
          (this.search_input_value || null) != (this.value || null);
        this._setValue(this.search_input_value);
        if (value_changed) {
          this.onChange(this.value);
        }
      }
    }
  }

  private _applyMatchValue(value): string {
    const search_value = this.search_input_value;

    try {
      return _.replace(
        value,
        new RegExp(search_value, "gi"),
        match_value => `<strong>${match_value}</strong>`
      );
    } catch (e) {
      console.warn(e);
      return value;
    }
  }

  private _ajustScroll(index: number = this.search_active_index) {
    if (this.schema.search_list.length == 0 || !_.isNumber(index)) {
      return;
    }
    const content = this.dropdown.nativeElement.parentNode;
    const options = content.getElementsByClassName("uex-input-dropdown-item");

    const content_scroll_top = content.scrollTop;
    const content_height = content.clientHeight;

    const selected_top = options[index].offsetTop;
    const selected_bottom = selected_top + options[index].clientHeight;

    if (content_scroll_top > selected_top) {
      content.scrollTop = selected_top;
    } else if (content_scroll_top + content_height < selected_bottom) {
      content.scrollTop = selected_bottom - content_height;
    }
  }
}
